import type { ListItem } from "../../components/List/List"
import { MemoryClass } from "./MemoryClass"
import { DeliveryEntity } from "../DeliveryEntity/DeliveryEntity"

export class DeliveryMemory extends MemoryClass<DeliveryEntity> {
  setList = (list: DeliveryEntity[]) => {
    this.listData = list
  }

  protected cloneEntity(item: DeliveryEntity): DeliveryEntity {
    return new DeliveryEntity({ ...item })
  }

  protected getItemId(item: DeliveryEntity): number {
    return item.id
  }

  getListCards = (all: boolean): ListItem[] => {
    var cards: ListItem[] = []
    let count = 0

    this.listData.forEach((ss) => {
      cards.push(this.getCard(ss, count))
    })

    count++

    return cards
  }

  getCard(e: DeliveryEntity, count: number): ListItem {
    return {
      isDisable: false,
      id: e.id,
      title: "",
      linkImage: "",
      index: count,
      dataFilter: [],
      children: <></>,
      body: <></>,
    }
  }
}
